import { useAtom } from 'jotai';
import { dateTypeAtom, guildIdAtom } from 'store';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { selectUserDataAtom } from 'store';
import { MemberTimeItem } from 'api/type';
import { memberTimeList } from 'api';
import { formaTimeForTsToH, sprintf } from 'utils/index';
import { _T } from '@dana/components';
import { Card } from 'components/data-details';
import Nav from 'components/nav';

export default function TimeDetail() {
  const [guildId] = useAtom(guildIdAtom);
  const [userInfo] = useAtom(selectUserDataAtom);

  const [dateType] = useAtom(dateTypeAtom);

  const navigate = useNavigate();

  const [list, setList] = useState<MemberTimeItem[]>();

  const fetchData = async () => {
    if (userInfo?.uid && userInfo?.date) {
      const res = await memberTimeList(userInfo?.uid, userInfo?.date, guildId, dateType === 'HALF_MONTH');
      setList(res);
    }
  };

  useEffect(() => {
    fetchData();
  }, [userInfo]);

  // useEffect(() => {
  //     console.log('zeze', userInfo)
  // }, [])

  return (
    <div className="bg-[#F2F5F5] pb-[12px]">
      <Nav title={'直播记录'}></Nav>
      <div
        className={`bg-[#F2F5F5] pt-[12px] overflow-scroll`}
        style={{
          height: `${window.innerHeight - 45}px`,
        }}
      >
        <div className="mx-auto pt-[12px] w-[351px] rounded-[8px] bg-white pb-[12px] mt-[12px]">
          <div className="flex justify-start">
            <div
              className="ml-[12px] w-[52px] h-[52px] rounded-full bg-cover"
              style={{
                backgroundImage: `url(${userInfo?.avatar})`,
              }}
            ></div>
            <div className="flex flex-col justify-start items-start ml-[12px]">
              <div
                className="mt-[10px] text-[#333] font-sans text-[14px] font-bold leading-[18px] truncate w-[190px]"
                dir="auto"
              >
                {userInfo?.nickName}
              </div>
              <div className="text-[#B3B3B3] font-sans text-[14px] font-semibold leading-[18px]">
                ID: {userInfo?.danaId}
              </div>
            </div>
          </div>
          <div className="mt-[12px] flex justify-around w-full">
            <Card
              type="big"
              name={_T('总直播时长')}
              value={sprintf(_T('{hour}小时'), {
                hour: formaTimeForTsToH(userInfo?.totalTime || 0),
              })}
            ></Card>
            <Card
              type="big"
              name={_T('>=2小时')}
              value={sprintf(_T('{day}天'), {
                day: userInfo?.day || '',
              })}
            ></Card>
          </div>
          <div className="ml-[12px] flex justify-around items-center w-[327px] h-[48px] rounded-[8px] bg-[#F5F7F7] mt-[12px]">
            <div className="text-[#B3B3B3] text-center font-sans text-[14px] font-bold" dir="auto">
              {_T('日期')}
            </div>
            <div className="text-[#B3B3B3] text-center font-sans text-[14px] font-bold" dir="auto">
              {_T('在麦时长')}
            </div>
          </div>
          <div className="rounded-[8px] bg-[#F5F7F7] flex flex-col justify-center items-center w-[327px] mx-auto mt-[12px] pb-[12px]">
            {list &&
              list.map((item) => (
                <div className="mt-[12px] w-full flex justify-around items-center">
                  <div
                    dir="auto"
                    className="text-[#333] text-center font-sans text-sm font-bold  -translate-x-[25px]"
                  >
                    {item.liveTime}
                  </div>
                  <div
                    dir="auto"
                    className="text-[#B3B3B3] text-center font-sans text-sm font-bold"
                  >
                    {formaTimeForTsToH(item.liveTotal)}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
